import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    monitoring_tables: 'Таблица',
    monitoring_charts: 'Диаграмма',
    monitoring_reportsVoucherHolders:'Отчеты по ваучеродержателям',
    monitoring_reportVoucherHoldersWaitingForPO:'Ваучеродержатели, ожидающие зачисления в ДО',
    monitoring_reportVoucherHoldersNotSelectPO:"Ваучеродержатели, не выбравшие ДО",
    monitoring_reportVoucherHoldersNotAcceptVoucher:'Заявители, не принявшие ваучер',
    monitoring_fromDate: 'дата с',
    monitoring_toDate: 'дата по',
    monitoring_service: 'Выберите услугу',
    monitoring_status: 'Выберите статус',
    monitoring_chartsStatus: 'Количество заявок в разрезе статусов, ед.',
    monitoring_chartsService: 'Количество заявок в разрезе услуг, ед.',
    monitoring_columnParentIIN:'ИИН родителя',
    monitoring_columnChildIIN:'ИИН ребенка',
    monitoring_columnParentFullName:'ФИО родителя',
    monitoring_columnChildFullName:'ФИО ребенка',
    monitoring_columnBinPO:'БИН ДО',
    monitoring_columnKatoCode:'Като код',
    monitoring_columnLangName:"Наименование ДО",
    monitoring_columnParentTelephoneNumber:'Номер телефон родителя',
    monitoring_staff_list_organizations: 'Список услугодателей',

    //column
    monitoring_columnDistrict: 'Район',
    monitoring_columnTypeCode: 'Тип организации',
    monitoring_columnSubTypes: 'Вид организации',
    monitoring_columnOrgName: 'Наименование организации',
    monitoring_columnAddress: 'Адрес',
    monitoring_columnContact: 'Контакты',
    monitoring_columnDesign_capacity: 'Проектная мощнось',
    monitoring_columnAvailabilitySpecConditions:'Наличие спец.условий',
    monitoring_columnClosed: 'Статус',
    monitoring_columnFormOwnership: 'Государственный',
    monitoring_columnIsGos: 'Городской',
    monitoring_columnYes: 'да',
    monitoring_columnNo: 'нет',
    monitoring_columnService: 'Наименование',
    monitoring_columnLocation: 'Населенный пункт',
    monitoring_columnSUBMITTED: 'Поступило',
    monitoring_columnIN_PROGRESS: 'В обработке',
    monitoring_columnREADY_FOR_SIGN: 'На подписи',
    monitoring_columnREADY_FOR_SIGN_POSITIVE: 'Ожидает подпись на положительный ответ',
    monitoring_columnREADY_FOR_SIGN_NEGATIVE: 'Ожидает подпись на отрицательный ответ',
    monitoring_columnIN_PROGRESS_IN_EXTERNAL_APP: 'Передано в ИС ОО',
    monitoring_columnCOMPLETED_POSITIVE: 'Положительно',
    monitoring_columnCOMPLETED_NEGATIVE: 'Отрицательно',
    monitoring_columnAllByRegion: 'Всего по региону',
    monitoring_columnAllByStatus: 'Всего по статусу',

    monitoringDucks_errorLoadTable: 'Не удалось загрузить данные',
    monitoring_excelAllServices: 'Все услуги',
    monitoring_excelPeriod: 'Период: с {{period.fromDate}} - по {{period.toDate}}',
    monitoring_excelService: 'Услуга: {{service}}',
    monitoring_excel_sheet_title: 'Отчеты',
    monitoring_export_btn: 'Экспортировать',
    monitoring_report_btn: 'Загрузить отчет',
    monitoring_children_preschool_education: 'Посещения детей по ДО',
    monitoring_staff_visits_organizations: 'Посещения персонала по организациям',
    monitoring_columnBin: 'БИН',
    monitoring_columnVisitedDays: 'Прибыл',
    monitoring_columnUnvisitedDaysWithReason: 'Не прибыл с причиной',
    monitoring_columnUnvisitedDaysWithoutReason: 'Не прибыл без причины',
    monitoring_columnTotalChildren: 'В общем детей',
    monitoring_columnTotalStaff: 'В общем сотрудников',
    monitoring_exportError: 'Не удалось экспортировать',
    monitoring_location: 'Населенный пункт'
  },
  kk: {
    monitoring_tables: 'Кесте',
    monitoring_charts: 'Диаграмма',
    monitoring_fromDate: 'күні,бастап',
    monitoring_toDate: 'күні,дейін',
    monitoring_service: 'Қызметті таңдаңыз',
    monitoring_status: 'Мәртебені таңдаңыз',
    monitoring_reportsVoucherHolders: 'Ваучер ұстаушылар бойынша есептер',
    monitoring_reportVoucherHoldersWaitingForPO: 'Оқу ұйымына тіркелуді күтетін ваучер ұстаушылар',
    monitoring_reportVoucherHoldersNotSelectPO: 'Оқу ұйымын таңдамаған ваучер ұстаушылар',
    monitoring_reportVoucherHoldersNotAcceptVoucher: 'Ваучерді қабылдамаған өтініш берушілер',
    monitoring_columnParentIIN: 'Ата-ананың ЖСН',
    monitoring_columnChildIIN: 'Баланыӊ ЖСН',
    monitoring_columnParentFullName: 'Ата-ананың ТАӘ',
    monitoring_columnChildFullName: 'Баланыӊ ТАӘ',
    monitoring_columnBinPO: 'Оқу ұйымының БСН',
    monitoring_columnKatoCode:'Като коды',
    monitoring_columnLangName: 'Оқу ұйымының атауы',
    monitoring_columnParentTelephoneNumber: 'Ата-ананың телефон нөмірі',
    monitoring_chartsStatus: 'Мәртебелер бөлінісінде өтінімдер саны, бірлік',
    monitoring_chartsService: 'Қызметтер бөлінісіндегі өтінімдер саны, бірлік',
    monitoring_staff_list_organizations: 'Қызмет көрсетушілер тізімі',

    // column
    monitoring_columnDistrict: 'Аудан',
    monitoring_columnTypeCode: 'Ұйым түрі',
    monitoring_columnSubTypes: 'Ұйымның түрі',
    monitoring_columnOrgName: 'Ұйым атауы',
    monitoring_columnAddress: 'Мекенжайы',
    monitoring_columnAvailabilitySpecConditions:'Арнайы шарттардың болуы',
    monitoring_columnContact: 'Байланыс деректері',
    monitoring_columnDesign_capacity: 'Жобалық қуаттылығы',
    monitoring_columnClosed: 'Мәртебесі',
    monitoring_columnFormOwnership: 'Мемлекеттік',
    monitoring_columnIsGos: 'Қалалық',
    monitoring_columnYes: 'иә',
    monitoring_columnNo: 'жоқ',
    monitoring_columnService: 'Атауы',
    monitoring_columnLocation: 'Аймақ',
    monitoring_columnSUBMITTED: 'Келіп түсті',
    monitoring_columnIN_PROGRESS: 'Өңделуде',
    monitoring_columnREADY_FOR_SIGN: 'Қолтаңба күтуде',
    monitoring_columnREADY_FOR_SIGN_POSITIVE: 'Оң жауап үшін қолтаңбаны күтуде',
    monitoring_columnREADY_FOR_SIGN_NEGATIVE: 'Теріс жауап үшін қолтаңбаны күтуде',
    monitoring_columnIN_PROGRESS_IN_EXTERNAL_APP: 'ББҰ АЖ-не берілді',
    monitoring_columnCOMPLETED_POSITIVE: 'Оң',
    monitoring_columnCOMPLETED_NEGATIVE: 'Теріс',
    monitoring_columnAllByRegion: 'Жалпы облыс бойынша',
    monitoring_columnAllByStatus: 'Жалпы мәртебе',

    //error
    monitoringDucks_errorLoadTable: 'Деректерді жүктеу мүмкін емес',
    monitoring_excelAllServices: 'Барлық қызметтер',
    monitoring_excelPeriod: 'Кезең: {{period.fromDate}} - {{period.toDate}}',
    monitoring_excelService: 'Қызметі: {{service}}',
    monitoring_excel_sheet_title: 'Есептер',
    monitoring_export_btn: 'Экспорттау',
    monitoring_report_btn: 'Есептерді жүктеу ',
    monitoring_children_preschool_education: 'ДО бойынша балалардың келуі',
    monitoring_staff_visits_organizations: 'Ұйымдар бойынша қызметкерлердің келуі',
    monitoring_columnBin: 'БИН',
    monitoring_columnVisitedDays: 'Келді',
    monitoring_columnUnvisitedDaysWithReason: 'Себеппен келмеді',
    monitoring_columnUnvisitedDaysWithoutReason: 'Себепсіз келмеді',
    monitoring_columnTotalChildren: 'Жалпы балалар',
    monitoring_columnTotalStaff: 'Жалпы қызметкерлер',
    monitoring_exportError: 'Экспорттау мүмкін болмады',
    monitoring_location: 'Аймақ'
  }
});
